export const GetAPI = () => {
  return "https://gkoj1i6yf0.execute-api.us-west-2.amazonaws.com/Prod";
  if (process.env.NODE_ENV === "production")
    return "https://gkoj1i6yf0.execute-api.us-west-2.amazonaws.com/Prod";
  else return "http://127.0.0.1:9090";
};



// WEBPACK FOOTER //
// ./src/tools/GetAPI.js